import App from "../../App";
import Notifications from "../Notifications/Notifications";
import Login from "../../../Pages/Login/Login";

const Forms = {

    settings: {
        library: null,
        event: null
    },
    sendProtection: 0,
    formEdited: false,
    submitButton: null,
    buttonPulseAfterEdit: false,
    saved: true,
    sendData: [],
    inputNotices: false,
    defaultNoticeIcon: 'save',

    init(el) {

        this.el = el;

        if (!this.el.length) {
            return;
        }

        this.start();
        this.bind();
    },

    start() {

        const settings = this.getFormSettings(this.el);

        if (!settings) {
            console.error("Missing form config");
            return;
        }

        this.setFormSettings(settings);
    },

    bind() {
        $(document).on("submit", "form", function (event) {
            event.preventDefault();

            clearTimeout(this.sendProtection);

            this.sendProtection = setTimeout(() => {
                Forms.send($(this));
            }, 500);
        });

        $(document).on("reset", "form", function (event) {
            setTimeout(() => {
                Forms.el.trigger("change");
                this.saved = true;
                this.formEdited = false;

                if ($(Forms.el).find("button[type='submit']")) {
                    $(Forms.el).find("button[type='submit']").each(function (i, el) {
                        let data = $(el).data();

                        if (data.reset) {
                            $(el).text(data.reset);
                        }
                    });
                }
            }, 100);
        });
        /*this.el.submit((event) => {
            event.preventDefault();

            clearTimeout(this.sendProtection);

            this.sendProtection = setTimeout(() => {
                Forms.send(event.currentTarget);
            }, 500);
        });*/

        this.el.change((event) => {
            this.formEdited = true;
            this.saved = false;

            if (/*this.buttonPulseAfterEdit &&*/ this.submitButton) {
                if ($('main[page]').length) {
                    Forms.getFormSubmitButton().addClass("highlight pulse");
                    //Forms.getFormSubmitButton().find('[element="indicator"]').addClass("pulse");
                } else {
                    Forms.getFormSubmitButton().addClass("pulse highlight");
                }
            }
        });

        this.el.find('input').on("change", function (element) {
            if (!Forms.inputNotices) {
                return;
            }

            let value = $(this).val();
            let parent = $(this).parents('[component="Input"]');

            parent.addClass('changed');

            Forms.appendNoticeToInput($(this), Forms.defaultNoticeIcon);
        });
    },

    setInputNotices(value) {
        this.inputNotices = value;
    },

    setFormSubmitButton(element) {
        this.submitButton = element;
    },

    getFormSubmitButton() {
        if (!this.submitButton) {
            console.warn("Missing submit button for this form:" + Forms.el);
        }
        return this.submitButton;
    },

    setResetButton(element) {
        this.resetButton = element;
    },

    getResetButton() {
        if (!this.resetButton) {
            console.warn("Missing reset button for this form:" + Forms.el);
        }
        return this.resetButton;
    },

    getFormSettings(element) {
        return element.data();
    },

    setFormSettings(settings) {
        this.settings = {
            ...settings
        };
    },

    setSendData(data) {
        this.sendData = data;
    },

    getSendData() {
        return this.sendData;
    },

    send(form) {
        let send = this.getSendData();

        if (!('data' in send)) {
            send = {
                data: this.getSendData()
            }
        }

        const post = {
            ...this.settings,
            ...send,//data: this.getSendData()//data || this.inputData(form)
        };

        $.ajax({
            url: App.ajaxUrl.switch,
            type: 'post',
            data: post,

            beforeSend: function (form) {
                Forms.beforeSend(form);
            },

            success: function (response) {
                if (!response) {
                    console.warn("Missing json response");
                    return;
                }
                Forms.success(form, JSON.parse(response));
            },

            error: function (response, textStatus, jqXHR) {
                if (!response) {
                    console.warn("Missing json response");
                    return;
                }
                Forms.error(form, JSON.parse(response), textStatus, jqXHR);
            },

        });
    },

    inputData(form) {
        const obj = {};

        $(form).find("input, textarea, select").not(":disabled").map(function () {
            let data;

            if ($(this).data("data")) {
                data = $(this).data("data");
            } else {

                if ($(this).hasClass('EDITOR')) {
                    data = $(this).html();
                } else {
                    data = this.value;
                }
            }

            obj[$(this).attr('name')] = data.replaceAll(/\s/g, '');
        });

        return obj;
    },

    inputData2(form) {

        let formData = new FormData(form[0]);

        formData.delete('search');

        return formData;
    },

    beforeSend() {
        App.showLoading();

        if ($(".loading").length) {
            Login.showLoading();
        }
    },

    success(form, response) {

        App.hideLoading();

        if (form) {
            Forms.resetSubmitButton();
            Forms.resetInputChanged();
        }

        Notifications.update_(response);

        if (response.redirect) {
            App.redirect(response.redirect);
        }

        if (response.reset_form || response.resetForm) {
            //if ( !$(form).is("#funds") ) {
            $(Forms.el)[0].reset();
            //}
        }

        if ($(".loading").length) {
            Login.hideLoading();
        }

        $('.littleLoading').fadeOut(1000, function () {
            $(this).remove();
        });

        if (response.hash) {
            let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?hash=' + response.hash;
            window.history.pushState({path: newurl}, '', newurl);
        }

        $.each(response.update, function (i, e) {
            setTimeout(() => {
                $(i).find('.ASYNC').trigger('click');
            }, 500);
        });

        this.saved = true;
    },

    error(form, response, textStatus, jqXHR) {
    },

    focusFirstInput(form, timeout = 1000) {
        if (!$(form).length) {
            return;
        }

        setTimeout(() => {
            let firstInput = $(form).find('input')[0];

            if ($(firstInput).attr("disabled")) {
                $(form).find('input')[1].focus();
                return;
            }

            $(form).find('input')[0].focus();
        }, timeout);
    },

    setButtonPulseAfterEdit() {
        this.buttonPulseAfterEdit = true;
    },

    resetSubmitButton() {
        if (Forms.getFormSubmitButton()) {
            Forms.getFormSubmitButton().removeClass("pulse highlight");
        }

        this.el.find('button[type="submit"]').removeClass("pulse highlight");
        this.el.find('[element="indicator"]').removeClass("pulse");
    },

    resetInputChanged() {
        this.el.find('[component="Input"]').removeClass("changed");
    },

    appendNoticeToInput(input, icon = "save") {
        let parent = $(input).parents('[component="Input"]');

        if (parent.find('.notice').length) {
            parent.find('.notice').remove();
        }

        parent.append("<div class='notice'><span class='icn material-symbols-outlined' title='Zmena nebola uložená'>" + icon + "</span></div>");
    }
}
export default Forms;